import { NgModule } from '@angular/core';
import { MaterialModule } from '../material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { RouterModule } from '@angular/router';
import { MetricsComponent } from './metrics.component';
import { SharedModule } from '../../shared/shared.module';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [BrowserModule, ReactiveFormsModule, MaterialModule, RouterModule, SharedModule, TranslateModule],
  declarations: [MetricsComponent]
})
export class MetricsModule {}



// WEBPACK FOOTER //
// ./src/app/modules/metrics/metrics.module.ts